import {
  NodesDependenciesActionTypes,
  NodesDependenciesActions
} from '../actions';
import { initialState } from '../state';
import {NodeDependencies} from "@ispm/shared/bpmn/models/node-dependencies";


export function nodeSelectionDependencies(state = initialState.nodeSelectionDependencies, action: NodesDependenciesActions): NodeDependencies {
  switch (action.type) {
    case NodesDependenciesActionTypes.UPDATE_NODES_DEPENDENCIES:
      return action.payload.nodeSelectionDependencies;
    default:
      return state;
  }
}
